import React, {Component} from "react";
import CmModal from "../../../components/CmModal/CmModal";
import CmForm from "../../../components/CmForm/CmForm";
import {Form, Input, InputNumber} from "antd";
import {message} from "../../../view/sysManagement/utils/sysManagementUtils";
import {validateName} from "../../../utils";

export default class EditTree extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editData: null
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.visible&&this.props.visible !== prevProps.visible) {
            this.setState({
                editData: initData(this.props.data || {})
            });
        }
    }

    render() {
        const {
            visible
        } = this.props;

        const {editData} = this.state;

        if (!editData) {
            return null;
        }
        const isCreate = !editData.id.value;
        const onDataChange = this.onDataChange;

        return (
            <CmModal
                visible={visible}
                width={480}
                handleCancel={this.handleCancel}
                handleOk={this.handleOk}
                title={isCreate ? "添加分组" : "修改分组"}
            >
                <CmForm>
                    <Form.Item
                        label={editData.name.label}
                        required={editData.name.required}
                    >
                        <Input
                            value={editData.name.value}
                            onChange={e => onDataChange({name: e.target.value})}
                            placeholder={editData.name.placeholder}
                        />
                    </Form.Item>
                    <Form.Item
                        label={editData.sort.label}
                        required={editData.sort.required}
                    >
                        <InputNumber
                            style={{width: 110}}
                            value={editData.sort.value}
                            onChange={value => onDataChange({sort: value})}
                            placeholder={editData.sort.placeholder}
                        />
                    </Form.Item>
                </CmForm>
            </CmModal>
        );
    }

    onDataChange = data => {
        const editData = this.state.editData;
        Object.keys(data).forEach(key => {
            editData[key].value = data[key];
        });
        this.setState({});
    };

    handleOk = () => {
        const {editData} = this.state;
        const data = {};
        const editDataKeys = Object.keys(editData);
        for (let i = 0; i < editDataKeys.length; i++) {
            const key = editDataKeys[i];
            data[key] = editData[key].value;
            if (editData[key].check && !editData[key].check(editData[key].value)) {
                return;
            }
        }
        this.props.handleOk(data);
    };

    handleCancel = () => {
        this.props.handleCancel();
    };

}

function initData(
    {
        name = "",
        id = "",
        sort = ""
    } = {}
) {
    return {
        id: {
            value: id
        },
        name: {
            value: name,
            required: true,
            label: "分组名称：",
            placeholder: "请输入分组名称",
            check: value => {
                if (!value) {
                    message.warn("分组名称不能为空！");
                    return false;
                }
                if(!validateName(value,{min:1,max:8})){
                    message.warn("分组名称只可填写中文、英文字母、数字及下划线，限制输入8个字符！")
                    return false
                }
                return true;
            }
        },
        sort: {
            value: sort ? sort : "",
            label: "排序：",
            placeholder: "请输入排序"
        }
    };
}

